/**
 * 輸入情報
 */
export class ImportInfo {
    /** 蔵地場所 */
    storagePlace = ""
    /** 抜取日 */
    samplingOn = ""
    /** 入船日 */
    arrivalOn = ""
    /** 船名 */
    shipName = ""
    /** 輸入業者 */
    importer = ""

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<ImportInfo>) {
        Object.assign(this, init)
    }
}
